export function HelpersBrokenIFrame (pEditor, pHelpers)
{
  let fixBrokenIFrameCounter = 1;


  this.reInit = () =>
  {
    fixBrokenIFrameCounter = 1;
  };


  this.testBrokenIFrame = () =>
  {
    if (BEditor.browser.isGecko)
    {
      try
      {
        if (pEditor.iFrame && (!pEditor.iFrame.name || (pEditor.iFrame.name && pEditor.iFrame.name !== pEditor.iFrameName)))
        {
          searchBrokenIFrame();
        }
      }
      catch (err)
      {
        searchBrokenIFrame();
      }
    }
  };


  function searchBrokenIFrame ()
  {
    let isFound = false,
        elements = pEditor.$winContent.document.body.querySelectorAll('IFRAME');

    for (let i = 0; pEditor.$winContent.frames[i]; i++)
    {
      try
      {
        if (pEditor.$winContent.frames[i].name && pEditor.$winContent.frames[i].name === pEditor.iFrameName)
        {
          pEditor.iFrame = pEditor.$winContent.frames[i];
          isFound = (pEditor.iFrame && pEditor.iFrame.nodeType !== 1);
          break;
        }
      }
      catch (err) {}
    }

    if (!isFound)
    {
      let win;

      for (let i = 0; i < elements.length; i++)
      {
        try
        {
          win = elements[i].contentWindow;

          if (win.name && win.name === pEditor.iFrameName)
          {
            pEditor.iFrame = win;
            break;
          }
        }
        catch (err) {}
      }
    }
  }


  function fixBrokenIFrame (isForced)
  {
    if (BEditor.browser.isGecko && ((isForced && pEditor.objIFrame) || (pEditor.objIFrame && pEditor.iFrame && pEditor.iFrameDoc && pEditor.iFrameDoc.location && pEditor.iFrameDoc.location.href && pEditor.iFrameDoc.location.href.toLowerCase().indexOf('editorcontentblank') == -1)))
    {
      pEditor.objIFrame.parentNode.innerHTML = '<iframe src="' + pEditor.blankPageURL + '" id="' + pEditor.iFrameId + '" name="' + pEditor.iFrameName + '" frameborder="0" scrolling="' + ((BEditor.browser.isIE) ? 'yes' : 'no') + '" hspace="0" vspace="0" marginwidth="0" marginheight="0" allowtransparency="true" style="width: 1px; height: 1px; ' + ((BEditor.browser.isIE) ? '' : 'overflow-x: auto; overflow-y: hidden;') + '"></iframe>' + ((!BEditor.browser.isIE) ? '<div id="' + pEditor.cutBoxId + '_Cup" style="position: absolute; left: 0; bottom: 0; width: 100%; height: 0; z-index: 7; overflow: hidden; background-color: transparent; background: none;"></div>' : '');
      pEditor.cutBoxCup = $(pEditor.cutBoxId + '_Cup');
      pEditor.objIFrame = $(pEditor.iFrameId);
      //pEditor.iFrame = pEditor.$winContent.frames[pEditor.iFrameName];
      pEditor.iFrame = (pEditor.objIFrame ? pEditor.objIFrame.contentWindow : null);

      try
      {
        if (pEditor.iFrame && (!pEditor.iFrame.name || (pEditor.iFrame.name && pEditor.iFrame.name !== pEditor.iFrameName)))
        {
          searchBrokenIFrame();
        }
      }
      catch (err)
      {
        searchBrokenIFrame();
      }

      fixBrokenIFrameCounter++;
      pEditor.waitIFrameCounter = 0;

      if (pEditor.cutBoxCup)
      {
        pEditor.cutBoxCup.onmousedown = pEditor.persistEditing;
        pEditor.cutBoxCup.onmouseup = pEditor.resetPersistEditing;
      }
    }
  }


  this.fixBrokenIFrameForced = () =>
  {
    fixBrokenIFrame(true);
  };


  this.fixBrokenIFrame = fixBrokenIFrame;

  Object.defineProperty(this, 'counter', { get: () => fixBrokenIFrameCounter });
}